import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconRecord = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 39,
			height: 39,
			rx: 19.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 39,
			height: 39,
			rx: 19.5,
			stroke: "#EDEEEF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15.4996,
			y: 16.4,
			width: .8,
			height: 8.2,
			fill: "#7E7E7E",
			stroke: "#7E7E7E",
			strokeWidth: .8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19.5992,
			y: 13.4,
			width: .8,
			height: 13.2,
			fill: "#7E7E7E",
			stroke: "#7E7E7E",
			strokeWidth: .8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 23.6998,
			y: 16.4,
			width: .8,
			height: 8.2,
			fill: "#7E7E7E",
			stroke: "#7E7E7E",
			strokeWidth: .8
		})
	]
});
const ForwardRef = forwardRef(SvgIconRecord);
export { ForwardRef as ReactComponent };
